
const digest = 'e5f61d9de9a224e711a42bc40aba4b2897de4bbddf271c89e40490948f742835';
const css = `._wordCountContainer_1te54_1 {
  padding: 0 var(--spacer-3);
  font-size: 12px;
}
._wordCountRow_1te54_5 {
  padding: var(--spacer-1) 0;
  display: flex;
  justify-content: space-between;
}
._wordCountRow_1te54_5:first-child {
  margin-bottom: var(--spacer-1);
  padding-bottom: var(--spacer-2);
  border-bottom: 1px solid var(--theme-light-border);
}
._count_1te54_15 {
  font-weight: 500;
  margin-right: var(--spacer-3);
}
._label_1te54_19 {
  color: var(--theme-secondary-text);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"wordCountContainer":"_wordCountContainer_1te54_1","wordCountRow":"_wordCountRow_1te54_5","count":"_count_1te54_15","label":"_label_1te54_19"};
export { css, digest };
  